import React, {useState, useEffect, useCallback} from 'react';
import {ArrowIcon} from '../../svg/ArrowIcon';
import {Typography} from '../../atoms/Typography';
import {Input} from '../../atoms/Input';
import {Button} from '../../atoms/Button';
import {coin} from '../../sass/base/_exports.sass';

const defaultSubscribeMessage = 'Join our email list for party tips, updates, and offers.';

export const NewsletterSignup = (props) => {
  const {subscribeMessage = defaultSubscribeMessage} = props;
  const [inputValue, setInputValue] = useState('');
  const [showFeedback, setShowFeedback] = useState(false);
  const [messageText, setMessageText] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const ariaProps = {
    'aria-describedby': `${isSuccess ? 'success' : 'error'}_message`,
  };
  const feedbackBlock = document.getElementById('newsletter-feedback');

  useEffect(() => {
    if (showFeedback && !isSuccess) {
      ariaProps['aria-invalid'] = true;
    }
  }, [showFeedback, isSuccess]);

  const handleAjaxResponse = (message, success = true) => {
    setMessageText(message);
    setIsSuccess(success);
    setShowFeedback(true);
    evite.removeClass(feedbackBlock, 'hidden');
  };

  const subscribe = useCallback(
    (e) => {
      e.preventDefault();

      const data = {
        email_addr: inputValue,
        marketing_source: 'site_footer',
      };

      $.ajax({
        url: '/ajax/subscribe/',
        dataType: 'json',
        type: 'POST',
        timeout: 10000,
        data,
        success(response) {
          handleAjaxResponse(response.message);
        },
        error(xhr) {
          handleAjaxResponse(xhr.responseJSON.message, false);
        },
      });
    },
    [inputValue, handleAjaxResponse]
  );

  const handleInputChange = (e) => {
    setShowFeedback(false);
    setMessageText('');
    setInputValue(e.target.value);
    evite.addClass(feedbackBlock, 'hidden');
  };

  return (
    <form className="evite-form" onSubmit={subscribe}>
      <ul id="newsletter-signup" className="newsletter-signup" role="presentation">
        <li className="header3 footer__subscribe" id="subscribe_message">
          <Typography as="h3" variant="header3">
            {subscribeMessage}
          </Typography>
        </li>
        <li className="newsletter-email">
          <Input
            type="text"
            data-qa-id="footer_email"
            className="newsletter-text-input"
            value={inputValue}
            success={isSuccess ? messageText : null}
            error={!isSuccess ? messageText : null}
            onChange={handleInputChange}
            placeholder="Enter your email address"
            endAdornment={
              <Button variant="transparent" onClick={subscribe} data-qa-id="footer_submit">
                <ArrowIcon ratio={0.5} color={coin} />
              </Button>
            }
          />
        </li>
      </ul>
    </form>
  );
};
